// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2WrxG","disabled":"FileBtn_disabled__3lXl0","warn":"FileBtn_warn__ZJ0xF","fade":"FileBtn_fade__3SLbI"};